<template>
    <div>
      <div v-if="isLoading">
        <v-progress-linear
          indeterminate
          color="primary"
          ></v-progress-linear>
      </div>
        <v-card>
            <v-card-title>Edit Article</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-form ref="form" v-model="isValid">
                    <v-text-field
                        filled
                        label="Title"
                        :rules="validation.title"
                        v-model="newsData.title"
                        @change="onTitleChange($event)"
                    ></v-text-field>
                    <redactor v-model="newsData.body"></redactor>
                    <br>
                    <v-card
                      elevation="1"
                    >
                    <v-card-title>
                      Add Writer
                    </v-card-title>
                      <v-card-text>
                        <v-autocomplete
                            filled
                            required
                            autocomplete="off"
                            label="Select Guest writer"
                            v-model="newsData.guest_writer_id"
                            clearable
                            item-text="name"
                            item-value="id"
                            v-bind:items="guestWriters"
                        ></v-autocomplete>

                        OR<br><br>

                        <v-autocomplete
                            filled
                            required
                            autocomplete="off"
                            label="Add Public Writer"
                            :loading="searching_pw"
                            hide-no-data
                            clearable
                            no-filter
                            @click:clear = "clearPublicWriter"
                            :search-input.sync="search"
                            v-model="newsData.public_writer"
                            item-text="name_address"
                            item-value="id_name"
                            :items="public_writers"
                        ></v-autocomplete>
                      </v-card-text>
                    </v-card>
                    <br>
                    <v-text-field
                      label="Select publish date"
                      solo
                      clearable
                      readonly
                      :rules="validation.publishDate"
                      v-model="formattedDate"
                      @click:clear="dateClearCallback"
                      prepend-icon="mdi-calendar"
                      @click="showDatePicker"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-btn
                  tile
                  color="primary"
                  class="mx-2"
                  :disabled="!isValid"
                  v-on:click="update"
                  v-bind:loading="isLoading"
                  >Update</v-btn
              >
              <v-spacer />
            </v-card-actions>
        </v-card>
        <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>

    </div>
</template>
<script>

import guestWriterApi from '@/api/gwApi'
import postApi from '@/api/postApi'

import snackbar from '@/utils/snackbar'
import urlUtils from '@/utils/urlUtils'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import * as dateFormats from '@/constants/dateFormats'
import publicWriterApi from '@/api/pwApi'
import Vue from 'vue'

import commonUtils from '@/utils/commonUtils'

import redactor from '@/components/Redactor.vue'

export default {
  components: {
    DatePickerDialog,
    redactor
  },
  props: {

  },
  mounted () {
    this.initData()
  },
  computed: {

  },
  data () {
    return {

      isValid: null,
      guestWriters: null,
      isLoading: false,
      formattedDate: null,
      search: null,
      searching_pw: false, // loader for public writer api call
      public_writers: [],
      showDatePickerDialog: false,
      // when this component is mounted and assigned inital value to public writer autocomplete view
      // search is triggered and hence clears the initial value.This will prevent it
      initialPublicWriter: null,
      validation: {
        title: [(v) => !!v || 'Please enter title'],
        publishDate: [(v) => !!v || 'Please enter publish date']
      },
      newsData: {
        id: null,
        title: '',
        body: '',
        guest_writer_id: null,
        publish_date: null,
        public_writer: null
      }

    }
  },
  watch: {
    search (val) {
      val && val !== this.select && this.trySearch(val)
    },
    'newsData.title': function (newVal, oldVal) {
      this.$log.info('title ', [newVal, oldVal])
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    }
  },
  methods: {
    trySearch: Vue.lodash.debounce(async function () {
      if (this.search === null || this.search === '' || this.search === this.initialPublicWriter) {
        return
      }
      this.searching_pw = true
      try {
        const q = { limit: 10, search: this.search }
        this.$log.info('searching @EditArticle', [q])

        const r = await publicWriterApi.search(q)
        if (r.data !== undefined) {
          this.public_writers = r.data
        }
      } finally {
        this.searching_pw = false
      }
    }, 500),
    clearPublicWriter () {
      this.$log.info('clearing public writer ')
      this.newsData.public_writer = null
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.newsData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.newsData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    callbackImgDeleteSuccess () {
      this.fetchArticle()
    },
    getImageFullUrl (url) {
      var k = urlUtils.getImageUrl(url)
      return k
    },
    async initData () {
      this.isLoading = true
      try {
        const response = await guestWriterApi.getGuestWriters({ all: true })
        this.guestWriters = response.data
        const cat = await postApi.getCategories()
        this.categories = cat.data
        this.fetchArticle()
      } finally {
        this.isLoading = false
      }
    },
    async fetchArticle () {
      this.isLoading = true
      try {
        const article = await postApi.getArticleById(this.$route.params.id)
        if (article.data !== undefined) {
          // this.$log.info('article data', [article.data])
          this.assignValues(article.data)
        }
      } finally {
        this.isLoading = false
      }
    },

    async update () {
      this.isLoading = true
      try {
        this.$log.info('updating article with params', [this.newsData])
        const response = await postApi.updateArticle(this.newsData)
        if (response.data !== undefined) {
          this.assignValues(response.data)
        }
        snackbar.show('Article updated successfully', 'success')
        window.publish_date = this.newsData.publish_date
        if (this.newsData.public_writer !== undefined && this.newsData.public_writer !== null) {
          this.$router.push('/public-article')
        } else {
          this.$router.push('/guest-article')
        }
      } finally {
        this.isLoading = false
      }
    },
    assignValues (data) {
      this.newsData.id = data.id
      this.newsData.title = data.title
      this.newsData.body = data.body
      this.newsData.publish_date = data.publish_date
      this.formattedDate = this.$moment(this.newsData.publish_date).format(dateFormats.DDMMYY)

      if (data.guest_writer !== undefined &&
            Array.isArray(data.guest_writer) &&
            data.guest_writer.length > 0
      ) {
        this.newsData.guest_writer_id = data.guest_writer[0].id
      }

      if (data.public_writer !== undefined &&
            Array.isArray(data.public_writer) &&
            data.public_writer.length > 0
      ) {
        const pw = data.public_writer[0]
        let nameAddress = ''
        if (pw.address === undefined || (pw.address !== undefined && pw.address.length <= 0)) {
          // we cant have trailing comma
          nameAddress = pw.name
        } else {
          nameAddress = pw.name + ',' + pw.address
        }
        this.public_writers = [{ id: pw.id, id_name: pw.id + '|' + pw.name, name_address: nameAddress }]

        this.$log.info('pw address', [pw.address])
        if (pw.address !== undefined && pw.address.length <= 0) {
          this.initialPublicWriter = pw.name
        } else {
          this.initialPublicWriter = pw.name + ',' + pw.address
        }
        this.newsData.public_writer = pw.id + '|' + pw.name
      }
    },

    onTitleChange (newVal, oldVal) {
      this.$log.info('Ontitle change', newVal, oldVal)
      this.newsData.title = commonUtils.parseStringForTri(newVal)
    }
  }
}
</script>

<style>
.ql-editor{
  min-height: 350px;
  font-size: 15px;
}
</style>
